var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MobileHeader'),_c('div',{staticClass:"mobile-content"},[_c('transition',{attrs:{"name":"router-animation"}},[_c('router-view'),_vm._v("\\ ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }